export default {
  items: [
    {
      title: 'Chat',
      id: 'Chat',
      to: null,
      icon: 'icon',
      sortOrder: 10,
      expanded: true,
      permission: 'chat access',
      children: [
        {
          title: 'Chat',
          to: { name : 'ChatIndexPage'},
          icon: 'user',
          sortOrder: 10,
          permission: 'chat access',
        },
        {
          title: 'chat.admin.title',
          to: { name : 'ChatAdminAuthorizationPage'},
          icon: 'shield',
          sortOrder: 20,
          permission: 'chat administer',
        },
        {
          title: 'chat.admin.userAccess',
          to: { name : 'ChatAdminUserAccessPage'},
          icon: 'users',
          sortOrder: 30,
          permission: 'chat administer',
        }
      ]
    }
  ]
}
